// extracted by mini-css-extract-plugin
export default {"root":"WaitlistButton_root__tkKfU","button":"WaitlistButton_button__GIzBp","buttonActive":"WaitlistButton_buttonActive__Y2C9D","notice":"WaitlistButton_notice__h9FFa"};